export function findRouteChildren(routeName, routes) {

  for (let route of routes) {
    let foundChildren;
    if (route.name === routeName) return route.children

    if (route.children?.length != undefined) {
      foundChildren = findRouteChildren(routeName, route.children)
    }

    if (foundChildren != undefined) return foundChildren
  }

  return undefined
}
export function naturalCompareOnName(a, b) {
  var ax = [],
    bx = [];

  a.name.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
    ax.push([$1 || Infinity, $2 || ""]);
  });
  b.name.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
    bx.push([$1 || Infinity, $2 || ""]);
  });

  while (ax.length && bx.length) {
    var an = ax.shift();
    var bn = bx.shift();
    var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
    if (nn) return nn;
  }

  return ax.length - bx.length;
}

export function naturalCompareOnKey(a, b) {
  var ax = [],
    bx = [];

  a.name.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
    ax.push([$1 || Infinity, $2 || ""]);
  });
  b.name.replace(/(\d+)|(\D+)/g, function (_, $1, $2) {
    bx.push([$1 || Infinity, $2 || ""]);
  });

  while (ax.length && bx.length) {
    var an = ax.shift();
    var bn = bx.shift();
    var nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
    if (nn) return nn;
  }

  return ax.length - bx.length;
}